App.ColorPickerComponent = Em.Component.extend
  classNames: ['color-picker-component']

  didInsertElement: ->
    picker = @$().colpick
      flat: true
      color: @get('color')
      layout: 'hex'
      onSubmit: (hsb, hex, rgb) =>
        @sendAction 'onColorChanged', "##{hex}"